import type { DeliveryEstimateAddress, DeliveryEstimateAddressResponse, ItemUI } from '@libs/common-node';
import { apiFetch, getLocale, HttpMethod, handleApiFetchResponse } from '@libs/core';

import { getNextApiRoute } from './api';

const locale = getLocale();

const DELIVERY_BASE_URL = getNextApiRoute('delivery'); // NOSONAR - Following deprecation notice's guidance to keep using for existing API routes until migrated

export const getDeliveryEstimate = async (
    address: Nullable<DeliveryEstimateAddress>,
    item: ItemUI
): Promise<DeliveryEstimateAddressResponse | undefined> => {
    const pickup = new Date();
    pickup.setDate(pickup.getDate() - 1); // This is how demandware calculated pickup date. Copied same logic for CPC-3833.

    const body = JSON.stringify({
        input: {
            dropoff_address: address,
            productId: item.sku,
            order_value: `${item.totalPrice}`,
            pickup_time: pickup.toISOString(),
        },
        locale,
    });

    const response = await apiFetch<DeliveryEstimateAddressResponse>(`${DELIVERY_BASE_URL}/estimate`, {
        method: HttpMethod.POST,
        body,
    });

    const result = handleApiFetchResponse(response);

    if (result?.store) {
        result.store.StoreNumber = String(result.store.StoreNumber).padStart(4, '0');
    }

    return result || undefined;
};
